import React from 'react';
import { JwtTokenEncoder } from '../components/jwt-token-encoder/JwtTokenEncoder';

export const JwtTokenEncoderPage: React.FC = () => {
  return (
    <div className="page-container">
      <JwtTokenEncoder />
    </div>
  );
};